import { viewsTypes } from '../../types';
import { getLocalStorage } from '../../../utils';

const defaultState = {
  view: null,
  isTimepadOpen: !!getLocalStorage('preferences')?.isTimepadOpen
};

const map = {
  // SET_VIEW
  [viewsTypes.SET_VIEW]: (state, { payload }) => ({
    ...state,
    view: payload.data
  }),
  [viewsTypes.TOGGLE_TIMEPAD]: (state, action) => ({
    ...state,
    isTimepadOpen: action.value
  })
};

export default (state = defaultState, action) =>
  (map[action.type] && map[action.type](state, action)) || state;
